// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root___BUQ5","title":"Images45_title__2XqdY","images":"Images45_images__1G_8O"};